import { createActions, handleActions, Action } from "redux-actions";

interface Marca {
  label: string;
  value: string;
}

interface FetchVehiculosMarcasCompletedPayload {
  marcas: Marca[];
}

interface VehiculoMarcasState {
  marcas: Marca[];
  isLoading: boolean;
}

// Tipado según la forma real en runtime: `~api/catalogos` declara `Promise<Marca[]>`
// para este endpoint, pero lo que llega es una lista de strings.
interface Services {
  api: {
    vehiculos: () => {
      getMarcas: () => Promise<string[]>;
    };
  };
}

export const fetchVehiculosMarcas = () => {
  return async (
    dispatch: (action: any) => void,
    getState: () => any,
    services: Services
  ) => {
    try {
      dispatch(fetchVehiculosMarcasInited());
      const response = await services.api.vehiculos().getMarcas();
      dispatch(fetchVehiculosMarcasCompleted(response));
    } catch (error) {
      dispatch(fetchVehiculosMarcasFailed(error));
    }
  };
};

const {
  vehiculoMarcasReducer: {
    clear,
    fetchVehiculosMarcasInited,
    fetchVehiculosMarcasCompleted,
    fetchVehiculosMarcasFailed,
  },
} = createActions({
  vehiculoMarcasReducer: {
    clear: () => ({}),
    setMarca: (value: Marca) => ({ value }),
    setModelo: (value: Marca) => ({ value }),
    //
    fetchVehiculosMarcasInited: () => ({}),
    fetchVehiculosMarcasCompleted: (
      response: string[] | null | undefined
    ): FetchVehiculosMarcasCompletedPayload => {
      let marcas: Marca[] = [];

      if (response != null && response.length !== 0) {
        marcas = response.map((x) => ({ value: x, label: x }));
      }

      return { marcas };
    },
    fetchVehiculosMarcasFailed: (error: unknown) => ({ error }),
  },
});

const initialState: VehiculoMarcasState = {
  marcas: [],
  isLoading: false,
};

export const vehiculoMarcasReducer = handleActions<VehiculoMarcasState, any>(
  {
    [clear.toString()]: (): VehiculoMarcasState => {
      return {
        ...initialState,
      };
    },
    [fetchVehiculosMarcasInited.toString()]: (
      state: VehiculoMarcasState
    ): VehiculoMarcasState => {
      return {
        ...state,
        isLoading: true,
      };
    },
    [fetchVehiculosMarcasCompleted.toString()]: (
      state: VehiculoMarcasState,
      action: Action<FetchVehiculosMarcasCompletedPayload>
    ): VehiculoMarcasState => {
      return {
        ...state,
        marcas: [...action.payload.marcas],
        isLoading: false,
      };
    },
    [fetchVehiculosMarcasFailed.toString()]: (
      state: VehiculoMarcasState
    ): VehiculoMarcasState => {
      return {
        ...state,
        isLoading: false,
      };
    },
  },
  initialState
);

export default vehiculoMarcasReducer;
export { clear };
